"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Products = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const FiltersComponent_1 = require("./FiltersComponent");
const table_1 = require("../../components/web-view/table");
const react_1 = require("react");
const usePagination_1 = require("../../hooks/pagination/usePagination");
const useIsMobile_1 = require("../../hooks/mobile/useIsMobile");
const react_i18next_1 = require("react-i18next");
const react_router_dom_1 = require("react-router-dom");
const useDebounce_1 = require("../../hooks/debounce/useDebounce");
const button_1 = require("primereact/button");
const products_module_scss_1 = __importDefault(require("./products.module.scss"));
const GenericButton_1 = require("../../components/web-view/button/GenericButton");
const ProductsList_1 = require("./mobile/ProductsList");
const useToast_1 = require("../../hooks/toast/useToast");
const CustomModal_1 = require("../../components/custom-modal/CustomModal");
const getAll_1 = require("../../modules/product/app/getAll");
const ApiProductRepo_1 = require("../../modules/product/infra/ApiProductRepo");
const deleteProduct_1 = require("../../modules/product/app/deleteProduct");
const RoleType_1 = require("../../common/enums/RoleType");
const FilterContext_1 = require("../../context/filters/FilterContext");
const AuthContext_1 = require("../../hooks/auth/context/AuthContext");
const productsRepo = (0, ApiProductRepo_1.createApiProductRepo)();
const Products = () => {
    const isMobile = (0, useIsMobile_1.useIsMobile)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { filters, setFilters } = (0, FilterContext_1.useFilters)();
    const [globalFilterValue, setGlobalFilterValue] = (0, react_1.useState)(filters.globalFilterValue || '');
    const [error, setError] = (0, react_1.useState)(null);
    const [confirmDelete, setConfirmDelete] = (0, react_1.useState)(false);
    const [productId, setProductId] = (0, react_1.useState)(null);
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [isInitialLoad, setIsInitialLoad] = (0, react_1.useState)(true);
    const { showSuccess, showError } = (0, useToast_1.useToast)();
    const { hasRole, isLoggedIn } = (0, AuthContext_1.useAuth)();
    const [currentPage, setCurrentPage] = (0, react_1.useState)(() => {
        const storedPage = localStorage.getItem('currentPage');
        return storedPage ? parseInt(storedPage, 10) : 1;
    });
    const debouncedFilterValue = (0, useDebounce_1.useDebounce)(globalFilterValue);
    const fetchProducts = (0, react_1.useCallback)(async (page = 1, pageSize = 10) => {
        try {
            return await (0, getAll_1.getAll)(productsRepo, page, pageSize, debouncedFilterValue.trim());
        }
        catch (err) {
            console.error('Fetch error:', err);
            setError('Error al cargar los datos');
            throw err;
        }
    }, [debouncedFilterValue, productsRepo]);
    const { data, loading, fetchData } = (0, usePagination_1.usePagination)(parseInt(localStorage.getItem('currentPage') || '1', 10), 10, fetchProducts, (product) => product.micronProductId);
    const onGlobalFilterChange = (0, react_1.useCallback)((e) => {
        const newFilters = {
            globalFilterValue: e,
            startDate: filters.startDate,
            endDate: filters.endDate,
            clubId: filters.clubId,
        };
        resetPageAndFetch(newFilters);
        if (e === '') {
            setIsInitialLoad(false);
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (isInitialLoad) {
            setIsInitialLoad(false);
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (isInitialLoad)
            return;
        const fetchProductData = async () => {
            try {
                // setIsLoading(true)
                await fetchData(currentPage, 10, false, debouncedFilterValue || '');
            }
            catch (err) {
                console.error('Error fetching products:', err);
            }
            finally {
                //setIsLoading(false)
            }
        };
        fetchProductData();
    }, [debouncedFilterValue, currentPage, isInitialLoad, isLoading]);
    const handlePageChange = (page) => {
        setCurrentPage(page);
        localStorage.setItem('currentPage', page.toString());
        fetchData(page, 10);
    };
    const resetPageAndFetch = (newFilters) => {
        setCurrentPage(1);
        localStorage.setItem('currentPage', '1');
        setGlobalFilterValue(newFilters.globalFilterValue);
        setFilters(newFilters);
    };
    const columns = [
        {
            field: 'thumbnailUrl',
            header: 'image',
            renderFunc: (product) => ((0, jsx_runtime_1.jsx)("div", { className: 'flex justify-center', children: (0, jsx_runtime_1.jsx)(ProductImage, { src: product.thumbnailUrl, alt: product.name }) })),
        },
        {
            field: 'name',
            header: 'name',
            renderFunc: (product) => {
                if (!product.name)
                    return '';
                return (0, jsx_runtime_1.jsx)("div", { className: "font-semibold text-gray-700", children: product.name });
            },
        },
        {
            field: 'retailPrice',
            header: 'price',
            renderFunc: (product) => {
                if (!product.retailPrice)
                    return '';
                return ((0, jsx_runtime_1.jsxs)("div", { className: "text-gray-700", children: [product.retailPrice.toFixed(2), " ", product.currency || 'EUR'] }));
            },
        },
        {
            field: 'weight',
            header: 'weight',
            renderFunc: (product) => {
                if (product.weight == null)
                    return '';
                return (0, jsx_runtime_1.jsxs)("div", { className: "text-gray-700", children: [product.weight || 0, " gr"] });
            },
        },
        {
            field: 'customCode',
            header: 'accountCategory',
            renderFunc: (product) => {
                if (!product.customCode)
                    return '';
                return (0, jsx_runtime_1.jsx)("div", { children: t(product.customCode) });
            },
        },
    ];
    const handlerGotoEdit = (product) => {
        navigate(`/products/${product.micronProductId}`, {
            state: { name: product.name },
        });
    };
    const openDeleteProductModal = (id) => {
        setProductId(id);
        setConfirmDelete(true);
    };
    const handleDelete = async (id) => {
        if (!id)
            return;
        try {
            await (0, deleteProduct_1.deleteProduct)(productsRepo, id);
            setConfirmDelete(false);
            setIsLoading(false);
            showSuccess(t('successDeleteProduct'));
        }
        catch (error) {
            if (error instanceof Error) {
                const message = error.message;
                const parsedError = JSON.parse(message.split('Conflict ')[1]);
                if (parsedError.status === 409) {
                    showError(t('errorDeleteProductConflict'));
                }
                else if (parsedError.status === 500) {
                    showError(t('errorDeleteProduct'));
                }
                else {
                    showError(t('errorDeleteProduct'));
                }
            }
            setConfirmDelete(false);
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", { children: [confirmDelete && ((0, jsx_runtime_1.jsx)(CustomModal_1.CustomModal, { visible: confirmDelete, onHide: () => setConfirmDelete(false), closable: false, title: ' ', children: (0, jsx_runtime_1.jsxs)("div", { className: 'rounded-md mt-2', children: [(0, jsx_runtime_1.jsx)("div", { className: 'flex justify-center text-center', children: (0, jsx_runtime_1.jsx)("h3", { children: t('sureDeleteProduct') }) }), (0, jsx_runtime_1.jsxs)("div", { className: products_module_scss_1.default.buttonContainer, children: [(0, jsx_runtime_1.jsx)(GenericButton_1.GenericButton, { className: products_module_scss_1.default.acceptButtonModal, label: t('accept'), onClick: () => handleDelete(productId) }), (0, jsx_runtime_1.jsx)(GenericButton_1.GenericButton, { label: t('cancel'), className: products_module_scss_1.default.cancelButtonModal, onClick: () => setConfirmDelete(false) })] })] }) })), isMobile ? ((0, jsx_runtime_1.jsx)(ProductsList_1.ProductsList, { products: data.items, handleEdit: handlerGotoEdit, handleDelete: openDeleteProductModal, globalFilterValue: globalFilterValue, onGlobalFilterChange: onGlobalFilterChange, fetchData: fetchData, loading: loading, pagination: data.pagination })) : ((0, jsx_runtime_1.jsx)("div", { className: products_module_scss_1.default.container, children: (0, jsx_runtime_1.jsx)(table_1.AppTable, { columns: columns, actions: (product) => {
                        return RenderActionButtons(product, handlerGotoEdit, openDeleteProductModal, hasRole(RoleType_1.RoleType.MANAGER));
                    }, fetchData: fetchData, data: data, loading: loading, getKey: (item) => item.micronProductId, globalFilterFields: ['micronProductId', 'name'], currentPage: currentPage, handleCurrentPage: handlePageChange, headerContent: (0, jsx_runtime_1.jsxs)("div", { className: 'w-full flex items-center justify-between', children: [(0, jsx_runtime_1.jsx)("h2", { children: t('productsList') }), hasRole(RoleType_1.RoleType.MANAGER) && ((0, jsx_runtime_1.jsx)("div", { className: 'ml-8 mr-2', children: (0, jsx_runtime_1.jsx)(GenericButton_1.GenericButton, { label: t('addProduct'), icon: "pi pi-plus", onClick: () => navigate('/products/create') }) }))] }), filtersComponent: (0, jsx_runtime_1.jsx)(FiltersComponent_1.FiltersComponent, { globalFilterValue: globalFilterValue, onGlobalFilterChange: onGlobalFilterChange }) }) }))] }));
};
exports.Products = Products;
const ProductImage = ({ src, alt }) => {
    const [hasError, setHasError] = (0, react_1.useState)(false);
    if (!src || hasError) {
        return ((0, jsx_runtime_1.jsx)("div", { className: products_module_scss_1.default.noImagePlaceholder, children: (0, jsx_runtime_1.jsx)("i", { className: "pi pi-image" }) }));
    }
    return ((0, jsx_runtime_1.jsx)("img", { src: src, alt: alt, className: products_module_scss_1.default.productImage, loading: "lazy", onError: () => setHasError(true) }));
};
const RenderActionButtons = (product, handlerGotoEdit, openDeleteProductModal, hasOneRole) => ((0, jsx_runtime_1.jsx)("div", { className: "flex justify-center gap-2", children: hasOneRole && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(button_1.Button, { icon: "pi pi-pencil", className: "p-button-rounded p-button-info p-button-outlined", onClick: () => handlerGotoEdit(product) }), (0, jsx_runtime_1.jsx)(button_1.Button, { icon: "pi pi-trash", className: "p-button-rounded p-button-info p-button-outlined", onClick: () => openDeleteProductModal(product.micronProductId) })] })) }));
